import { Http } from '@gamiphy/http';
import { App, AppTypes } from '@gamiphy/bl/app';

export type GetAppResponse = {
  app: App
}

export type ListAppsQuery = {
  search?: string,
  type: AppTypes,
  limit?: number,
  skip?: number
}

export type ListAppsResponse = {
  apps: App[],
  count: number
}
export class AppApi {
  public static async getApp(appId: string): Promise<App> {
    const response = await Http.get<GetAppResponse>({
      url: `/v2/apps/${appId}`,
      headers: {
        'gamix-app-id': appId,
      },
    });

    return response.data.app;
  }

  public static async updateApp(appId: string, data: Partial<App>): Promise<App> {
    const response = await Http.patch<GetAppResponse>({
      url: `/v2/apps/${appId}`,
      headers: {
        'gamix-app-id': appId,
      },
      payload: data,
    });

    return response.data.app;
  }

  public static async enableApp(appId: string): Promise<App> {
    const response = await Http.put<GetAppResponse>({
      url: `/v2/apps/${appId}/enable`,
      headers: {
        'gamix-app-id': appId,
      },
    });
    return response.data.app;
  }

  public static async disableApp(appId: string): Promise<App> {
    const response = await Http.put<GetAppResponse>({
      url: `/v2/apps/${appId}/disable`,
      headers: {
        'gamix-app-id': appId,
      },
    });
    return response.data.app;
  }

  public static async getAppByIdentifier(identifier: string): Promise<App> {
    const response = await Http.get<GetAppResponse>({
      url: `/v2/apps/identifier/${identifier}`,
    });

    return response.data.app;
  }

  public static async listApps(query: ListAppsQuery): Promise<ListAppsResponse> {
    const response = await Http.get<ListAppsResponse>({
      url: 'v2/apps',
      query,
    });

    return response.data;
  }
}
